module.exports = __webpack_public_path__ + "img/glasses-img2.4a6fddbd.png";